// extracted by mini-css-extract-plugin
export var stepHeaderHeaderSeparator = "step-header__header-separator_ZI95fUlWWyoHCAHOQYmv";
export var stepHeaderSubHeader = "step-header__sub-header_als_f0DoCewfrDT6UYyU";